import React from 'react';

import Drawer from '@mui/material/Drawer';

import { useTranslation } from "react-i18next";

import MultiCheckBox from '../MultiCheckBox';

import dayjs from 'dayjs';
import fr from 'date-fns/locale/fr-CA';
import en from 'date-fns/locale/en-CA';
import subDays from "date-fns/subDays";
import addDays from "date-fns/addDays";

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const CompareDrawer = (props) => {

  const [t] = useTranslation('common');
  const { i18n } = useTranslation('home');

  let list = () => (
    <div
      style={{ width: "350px" }}
      role="presentation"
    >
      <h2 className="pt-2 pb-2 text-center">{t('compareperiods.filters')}</h2>

      <div className="overflow-y-scroll pt-1 ps-2" style={{ maxHeight: "90vh" }}>

        <h3>{t('compareperiods.period1')}</h3>
        <DatePicker
          selected={props.startDate}
          onChange={props.onChange}
          startDate={props.startDate}
          endDate={props.endDate}
          selectsRange
          inline
          locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
          excludeDateIntervals={[
            {
              start: subDays(new Date('2000-01-01'), 0),
              end: addDays(new Date('2023-07-01'), 0)
            },
            {
              start: subDays(new Date(), 1),
              end: addDays(new Date('2030-12-31'), 0)
            },
          ]}
        />

        <h3 className="pt-4">{t('compareperiods.period2')}</h3>
        <DatePicker
          selected={props.startDateComp}
          onChange={props.onChangeComp}
          startDate={props.startDateComp}
          endDate={props.endDateComp}
          selectsRange
          inline
          locale={i18n.language.substring(0, 2) == 'fr' ? fr : en}
          excludeDateIntervals={[
            {
              start: subDays(new Date('2000-01-01'), 0),
              end: addDays(new Date('2023-07-01'), 0)
            },
            {
              start: subDays(new Date(), 1),
              end: addDays(new Date('2030-12-31'), 0)
            },
          ]}
        />

        <h3 className="pt-4">{t('compareperiods.days')}</h3>
        <div className="col pb-3">
          <div type="button" className={props.service == "tous" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.all')}</div>
          <div type="button" className={props.service == "se" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.week')}</div>
          <div type="button" className={props.service == "fds" ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
            onClick={(e) => props.handleDayTypeClick(e, props.t, props.setService, props.setRecalcAvg)} >{t('compareperiods.weekends')}</div>
        </div>

        <h3 className="pt-3">{t('compareperiods.period')}</h3>
        <div className="col pb-3">
        {['all', 'morning', 'am', 'offpeak', 'pm', 'evening'].map((buttonId) => (
              <div
                type="button"
                key={buttonId}
                className={props.period.includes(buttonId) ? "btn btn-dark me-1 mt-1" : "btn btn-outline-dark me-1 mt-1"}
                onClick={(e) => props.handleMultiPeriodClick(e, t, props.period, props.setPeriod, buttonId)}
              >
                {t(`compareperiods.${buttonId}`)}
              </div>
            ))}
       
        </div>

        <div className="row pt-3 pb-3">
          <h3>{t('datatable.routes')}</h3>
          <MultiCheckBox
            options={props.routes.map((e) => e.route_id)}
            handleMultiRoutes={props.handleMultiRoutes}
            selectedRoutes={props.selectedRoutes}
            setSelectedRoutes={props.setSelectedRoutes}
          />
        </div>

        {props.error==true ? 
      <Stack className="pt-2 pb-2" sx={{ width: '100%' }} spacing={2}>
        <Alert severity="error">{t('compareperiods.alert')}</Alert>
      </Stack>
      :''}

        <div className="text-center pt-3 pb-3">
          <div type="button" className="btn btn-primary me-1" onClick={props.handleFilters} >{t('compareperiods.apply')}</div>
        </div>

      </div>

    </div>

  );

  return (
    <Drawer anchor={'left'} open={props.open} onClose={props.toggle}>
      {list('left')}
    </Drawer>
  )

}

export default CompareDrawer;